import transactionsService from '@/services/transactions'

const state = {
    columns: [
        { key: 'id', visible: true },
        { key: 'date', visible: true },
        { key: 'type', visible: true },
        { key: 'amount', visible: true },
        { key: 'description', visible: true },
        { key: 'category', visible: true },
        { key: 'status', visible: true },
    ],
    filterParams: {
        page: 1,
        perPage: 50,
        search: '',
        dateRange: {
            startDate: null,
            endDate: null,
        },
        type: 'income', // 'income' veya 'expense'
        categoryFilter: '', // Kategori filtresi
        frequencyFilter: '', // Frequency (Tür) filtresi
    },
    incomes: {
        items: [],
        total: 0,
        lastUpdate: null,
        loading: false,
        error: null,
    },
    expenses: {
        items: [],
        total: 0,
        lastUpdate: null,
        loading: false,
        error: null,
    },
    summary: {
        data: {},
        lastUpdate: null,
        loading: false,
        error: null,
    },
    categories: {
        items: [],
        total: 0,
        lastUpdate: null,
        loading: false,
        error: null,
    },
    transactionDetails: {
        items: [],
        total: 0,
        lastUpdate: null,
        loading: false,
        error: null,
    },
    selectedRows: [],
}

const getters = {
    totalPages: (state) => (type) => {
        const list = type === 'income' ? state.incomes : state.expenses
        return Math.ceil(list.total / state.filterParams.perPage) || 1
    },
    getActiveList: (state) => (type) => {
        return type === 'income' ? state.incomes : state.expenses
    },
    getFormattedTransactions: (state) => (type) => {
        const list = type === 'income' ? state.incomes.items : state.expenses.items

        if (!list || !Array.isArray(list)) {
            return []
        }

        return list.map((item) => ({
            id: item.id,
            market_id: item.market_id,
            amount: item.amount,
            running_balance: item.running_balance,
            currency: item.currency,
            currency_original: item.currency_original,
            amount_original: item.amount_original,
            category: item.category,
            transaction_type: item.transaction_type,
            transaction_id: item.transaction_id,
            reason: item.reason,
            reason_detail: item.reason_detail,
            transaction_date: item.transaction_date,
            created_at: item.created_at,
            frequency: item.frequency || 'ONCE', // Eğer yoksa varsayılan bir değer
            hasDetail: item.hasDetail || 0,
        }))
    },
    getTransactionDetails: (state) => {
        return state.transactionDetails
    },
    getCategoryList: (state) => {
        return state.categories.items.map((item) => item.category_name)
    },
    getCategoriesLoading: (state) => {
        return state.categories.loading
    },
}

const mutations = {
    SET_COLUMNS(state, columns) {
        state.columns = columns
    },
    SET_COLUMN_TOGGLE(state, index) {
        state.columns[index].visible = !state.columns[index].visible
    },
    SET_FILTER_PARAMS(state, { key, value }) {
        state.filterParams[key] = value
    },
    SET_INCOME_LIST(state, data) {
        state.incomes = {
            ...state.incomes,
            items: data.items || [],
            total: data.total || 0,
            lastUpdate: new Date(),
        }
    },
    SET_EXPENSE_LIST(state, data) {
        state.expenses = {
            ...state.expenses,
            items: data.items || [],
            total: data.total || 0,
            lastUpdate: new Date(),
        }
    },
    SET_SUMMARY_DATA(state, data) {
        // API'den gelen yanıtın yapısını kontrol et ve buna göre veriyi işle
        let items = []

        // API yanıtında data ve items alanını kontrol et
        if (data && data.data && Array.isArray(data.data)) {
            items = data.data
        } else if (data && Array.isArray(data)) {
            items = data
        }

        state.summary = {
            ...state.summary,
            data: {
                items: items,
                total: data.total || items.length || 0,
            },
            lastUpdate: new Date(),
        }

        console.log('SET_SUMMARY_DATA işlendi:', state.summary)
    },
    SET_SELECTED_ROWS(state, rows) {
        state.selectedRows = rows
    },
    SET_LOADING(state, { type, isLoading }) {
        if (type === 'income') {
            state.incomes.loading = isLoading
        } else if (type === 'expense') {
            state.expenses.loading = isLoading
        } else if (type === 'summary') {
            state.summary.loading = isLoading
        }
    },
    SET_ERROR(state, { type, error }) {
        if (type === 'income') {
            state.incomes.error = error
        } else if (type === 'expense') {
            state.expenses.error = error
        } else if (type === 'summary') {
            state.summary.error = error
        }
    },
    CLEAR_TRANSACTION_LIST(state, type) {
        if (type === 'income') {
            state.incomes.items = []
        } else if (type === 'expense') {
            state.expenses.items = []
        }
    },
    SET_CATEGORIES(state, data) {
        state.categories = {
            ...state.categories,
            items: data.data || [],
            total: data.total || 0,
            lastUpdate: new Date(),
        }
    },
    SET_CATEGORIES_LOADING(state, isLoading) {
        state.categories.loading = isLoading
    },
    SET_CATEGORIES_ERROR(state, error) {
        state.categories.error = error
    },
    CLEAR_TRANSACTION_DETAIL_LIST(state) {
        state.transactionDetails.items = []
    },
    SET_TRANSACTION_DETAIL_LIST(state, data) {
        state.transactionDetails = {
            ...state.transactionDetails,
            items: data.items || [],
            total: data.total || 0,
            lastUpdate: new Date(),
        }
    },
    SET_TRANSACTION_DETAIL_LOADING(state, isLoading) {
        state.transactionDetails.loading = isLoading
    },
    SET_TRANSACTION_DETAIL_ERROR(state, error) {
        state.transactionDetails.error = error
    },
}

const actions = {
    async getTransactions({ commit, state }, type = state.filterParams.type) {
        commit('CLEAR_TRANSACTION_LIST', type)
        commit('SET_LOADING', { type, isLoading: true })
        commit('SET_ERROR', { type, error: null })

        try {
            // API isteği için parametreleri hazırla
            const params = {
                page: state.filterParams.page,
                perPage: state.filterParams.perPage,
            }

            // Arama sorgusu varsa, parametrelere ekle
            if (state.filterParams.search) {
                params.search = state.filterParams.search
            }

            // Tarih aralığı parametresi varsa ekle
            if (state.filterParams.dateRange.startDate && state.filterParams.dateRange.endDate) {
                params.startDate = state.filterParams.dateRange.startDate
                params.endDate = state.filterParams.dateRange.endDate
            }

            // Kategori filtresi varsa ekle
            if (state.filterParams.categoryFilter) {
                params.category = state.filterParams.categoryFilter
            }

            // Frequency (Tür) filtresi varsa ekle
            if (state.filterParams.frequencyFilter) {
                params.frequency = state.filterParams.frequencyFilter
            }

            console.log('Vuex getTransactions çağrısı, type:', type, 'params:', params)

            const response = await transactionsService.getTransactions(type, params)

            // API'den gelen yanıtın yapısını kontrol et ve buna göre veriyi işle
            const responseData = response.data

            let items = []
            let total = 0

            // Eğer response.data.data varsa (sayfalama yapısı içeren API yanıtı için)
            if (responseData && responseData.data && Array.isArray(responseData.data)) {
                items = responseData.data
                total = responseData.total || responseData.data.length
            }
            // Eğer response.data bir dizi ise
            else if (responseData && Array.isArray(responseData)) {
                items = responseData
                total = responseData.length
            }
            // Diğer durumlar için
            else {
                items = []
                total = 0
                console.warn('Unexpected API response format:', responseData)
            }

            const data = {
                items,
                total,
            }

            if (type === 'income') {
                commit('SET_INCOME_LIST', data)
            } else {
                commit('SET_EXPENSE_LIST', data)
            }
        } catch (error) {
            console.error('Error fetching transactions:', error)
            commit('SET_ERROR', { type, error: error.message || 'Veri yüklenirken bir hata oluştu.' })
        } finally {
            commit('SET_LOADING', { type, isLoading: false })
        }
    },

    async getTransactionDetails({ commit, state }, id) {
        commit('CLEAR_TRANSACTION_DETAIL_LIST')
        commit('SET_TRANSACTION_DETAIL_LOADING', true)
        commit('SET_TRANSACTION_DETAIL_ERROR', null)

        try {
            const params = {
                page: state.filterParams.page,
                perPage: state.filterParams.perPage,
            }
            if (state.filterParams.search) {
                params.search = state.filterParams.search
            }

            // Tarih aralığı parametresi varsa ekle
            if (state.filterParams.dateRange.startDate && state.filterParams.dateRange.endDate) {
                params.startDate = state.filterParams.dateRange.startDate
                params.endDate = state.filterParams.dateRange.endDate
            }

            const response = await transactionsService.getTransactionDetails(id, params)

            const responseData = response.data

            let items = []
            let total = 0

            if (responseData && responseData.data && Array.isArray(responseData.data)) {
                items = responseData.data
                total = responseData.total || responseData.data.length
            }
            // Eğer response.data bir dizi ise
            else if (responseData && Array.isArray(responseData)) {
                items = responseData
                total = responseData.length
            }
            // Diğer durumlar için
            else {
                items = []
                total = 0
                console.warn('Unexpected API response format:', responseData)
            }

            const data = {
                items,
                total,
            }

            commit('SET_TRANSACTION_DETAIL_LIST', data)
        } catch (error) {
            console.error('Error fetching transaction details:', error)
            commit('SET_TRANSACTION_DETAIL_ERROR', error.message || 'İşlem detayları yüklenirken bir hata oluştu.')
        } finally {
            commit('SET_TRANSACTION_DETAIL_LOADING', false)
        }
    },
    async getTransactionsSummary({ commit, state }) {
        commit('SET_LOADING', { type: 'summary', isLoading: true })
        commit('SET_ERROR', { type: 'summary', error: null })

        try {
            const params = {
                page: state.filterParams.page,
                perPage: state.filterParams.perPage,
            }

            // Tarih aralığı parametresi varsa ekle
            if (state.filterParams.dateRange.startDate && state.filterParams.dateRange.endDate) {
                params.startDate = state.filterParams.dateRange.startDate
                params.endDate = state.filterParams.dateRange.endDate
            }

            // Arama parametresi varsa ekle
            if (state.filterParams.search) {
                params.search = state.filterParams.search
            }

            // Kategori filtresi varsa ekle
            if (state.filterParams.categoryFilter) {
                params.category = state.filterParams.categoryFilter
            }

            const response = await transactionsService.getTransactionsSummary(params)
            commit('SET_SUMMARY_DATA', response.data)
        } catch (error) {
            console.error('Error fetching transactions summary:', error)
            commit('SET_ERROR', { type: 'summary', error: error.message || 'Özet verileri yüklenirken bir hata oluştu.' })
        } finally {
            commit('SET_LOADING', { type: 'summary', isLoading: false })
        }
    },

    async createTransaction({ dispatch, state }, transaction) {
        try {
            await transactionsService.createTransaction(transaction)
            // İşlem tipine göre listeyi yenile
            await dispatch('getTransactions', transaction.type || state.filterParams.type)
            return { success: true }
        } catch (error) {
            console.error('Error creating transaction:', error)
            return { success: false, error: error.message || 'İşlem eklenirken bir hata oluştu.' }
        }
    },

    async updateTransaction({ dispatch, state }, { id, transaction }) {
        try {
            await transactionsService.updateTransaction(id, transaction)
            // İşlem tipine göre listeyi yenile
            await dispatch('getTransactions', transaction.type || state.filterParams.type)
            return { success: true }
        } catch (error) {
            console.error('Error updating transaction:', error)
            return { success: false, error: error.message || 'İşlem güncellenirken bir hata oluştu.' }
        }
    },

    async deleteTransaction({ dispatch, state }, { id, type }) {
        try {
            await transactionsService.deleteTransaction(id)
            // İşlem tipine göre listeyi yenile
            await dispatch('getTransactions', type || state.filterParams.type)
            return { success: true }
        } catch (error) {
            console.error('Error deleting transaction:', error)
            return { success: false, error: error.message || 'İşlem silinirken bir hata oluştu.' }
        }
    },

    updateFilterParams({ commit, dispatch }, { key, value, fetchData = false }) {
        commit('SET_FILTER_PARAMS', { key, value })

        // Sadece fetchData=true olduğunda veri çek
        if (fetchData && (key === 'page' || key === 'perPage' || key === 'dateRange' || key === 'search' || key === 'categoryFilter' || key === 'frequencyFilter')) {
            dispatch('getTransactions')
        }
    },

    async getCategories({ commit }, { type, search = '', all = false }) {
        commit('SET_CATEGORIES_LOADING', true)
        commit('SET_CATEGORIES_ERROR', null)

        try {
            const response = await transactionsService.getCategories(type, search, all)
            commit('SET_CATEGORIES', response.data)
            return response.data
        } catch (error) {
            console.error('Error fetching categories:', error)
            commit('SET_CATEGORIES_ERROR', error.message || 'Kategoriler yüklenirken bir hata oluştu.')
            return { data: [], total: 0 }
        } finally {
            commit('SET_CATEGORIES_LOADING', false)
        }
    },
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
}
